import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { VinterAICommentIcon } from '@app/shared/common/constants';
import { EApplicantBehaviourEventType, EDecisionType, EDetectionType, EFaceDetectionStatus, EntityStateEnum, GPTEvalStatus, ProcessStatus } from '@app/shared/common/enums';
import { AnswerContentFormItem } from '@app/vinter/models/answer-content-form-item';
import { CodingAnswerItem } from '@app/vinter/models/answer/coding-answer-item';
import { ApplicantRecordItem, ApplicantRecordLogItem } from '@app/vinter/models/applicant-record-item';
import { ApplicantRecordService } from '@app/vinter/services/ApplicantRecord.service';
import { AnswerContentService } from '@app/vinter/services/answer-content.service';
import { ApplicantBehaviourEventLogService } from '@app/vinter/services/applicant-behaviour-event-log.service';
import { ApplicantDetailBehaviorCommunicationService } from '@app/vinter/services/applicant-detail-behavior-analysis-communation.service';
import { ApplicantRecordLogService } from '@app/vinter/services/applicant-record-log.service';

@Component({
  selector: 'app-coding-answer',
  templateUrl: './coding-answer.component.html',
  styleUrls: ['./coding-answer.component.scss']
})
export class CodingAnswerComponent implements OnInit {
  @Input() answer: CodingAnswerItem;
  @Input() questionId: string;
  @Input() ApplicationStepId: string;
  @Output() updateSuspicionOfCheating: EventEmitter<ApplicantRecordLogItem> = new EventEmitter<ApplicantRecordLogItem>();
  gptEvalStatusEnum = GPTEvalStatus;
  processStatusEnum = ProcessStatus;
  parsedCodingAnalysisResultDetail: any;
  vinterAICommentIcon = VinterAICommentIcon;
  questionPageHiddenLog: number;
  EFaceDetectionStatus = EFaceDetectionStatus;
  showDetails = false;
  CheatingPicturesUrls: any = "";
  isFaceDivVisible = true;
  isMultiFaceDivVisible = true;
  isNonFaceDivVisible = true;
  decisionTypeEnum = EDecisionType;
  detectionTypeEnum = EDetectionType;

  constructor(private answerContentService : AnswerContentService,
    private applicantRecordService : ApplicantRecordService,
    private applicantDetailBehaviorCommunicationService : ApplicantDetailBehaviorCommunicationService,
    private applicantRecordLogService : ApplicantRecordLogService,
    private eventLogService: ApplicantBehaviourEventLogService
  ){}

  ngOnChanges(changes: SimpleChanges): void {
    if(this.answer){
      this.showDetails = false;
      this.CheatingPicturesUrls  = "";
      if (this.answer?.codingAnalysis ?? false) {
        this.parsedCodingAnalysisResultDetail = (JSON.parse(this.answer.codingAnalysis.analysisResultDetail.toString()));
      }
      this.getPageHiddenLog();
    }
  }
  
  ngOnInit(): void {
    if(this.answer){
      if (this.answer?.codingAnalysis ?? false) {
        this.parsedCodingAnalysisResultDetail = (JSON.parse(this.answer.codingAnalysis.analysisResultDetail.toString()));
      }
      this.getPageHiddenLog();
    }
    
  }

  setGptStatus(){
    let answerContentForm : AnswerContentFormItem = new AnswerContentFormItem();
    answerContentForm = this.answer?.answerContent;
    answerContentForm.gptEvalStatus = this.gptEvalStatusEnum.Waiting;
    answerContentForm.processStatus = this.processStatusEnum.AIContainerWaiting;
    answerContentForm.entityState = EntityStateEnum.Modified;
    answerContentForm.xmin = this.answer?.answerContent?.xmin;
  
    this.answerContentService.SaveAsync(answerContentForm).subscribe();
  }
  getPageHiddenLog(){
    let eventLogFilter: any = {};
    eventLogFilter.applicationStepId = this.answer.applicationStepId;
    eventLogFilter.eventType = EApplicantBehaviourEventType.PageHidden;
    eventLogFilter.questionId = this.answer.questionId;
    this.eventLogService.getListByFilter(eventLogFilter).subscribe(eventLog => {
        this.questionPageHiddenLog = eventLog.length;
    });
}
getApplicantRecord()
{
  if (this.answer?.isFaceDetected ||
    this.answer?.isMultiFaceDetected ||
    this.answer?.faceDetectionStatus === EFaceDetectionStatus.UnverifiedAndNonFace ||
    this.answer?.faceDetectionStatus === EFaceDetectionStatus.VerifiedAndNonFace
  ) {
    const recordItem: ApplicantRecordItem = {
      questionId: this.questionId,
      applicationStepId: this.ApplicationStepId,
      filePathUrl: null
    };
  
    this.applicantRecordService
    .ListImagesInApplicantFolderAsync(recordItem)
    .subscribe({
      next: (result) => {
        if (result) {
          this.CheatingPicturesUrls = result;
        } else {
          console.error(result);
        }
      },
      error: (err) => console.error(err)
    });
}
}
toggleDetails() {
  this.showDetails = !this.showDetails;
  if (this.showDetails && this.CheatingPicturesUrls?.length === 0) {
    this.getApplicantRecord();
  }
}
hideWarningAndSaveLog(detType: EDetectionType, decType: EDecisionType) {
  const LogItem: ApplicantRecordLogItem = {
    questionId: this.questionId,
    applicationStepId: this.ApplicationStepId,
    decisionType :decType,
    detectionType : detType, 
  };
  
  this.applicantRecordLogService
    .SaveHRApplicantRecordLogAsync(LogItem).subscribe();

    if (detType == EDetectionType.FaceDetected)
      { 
        this.isFaceDivVisible = false;
        this.showDetails = false;
        if(decType == EDecisionType.HRRejected)
          {
            this.applicantDetailBehaviorCommunicationService.requestTabUpdate();
            this.answer.isFaceDetected = false;
            this.answer.isAllowedDifferentFaceAnalysis = false;
            this.updateSuspicionOfCheating.emit(LogItem)
          }
      }
    if (detType == EDetectionType.MultiFaceDetected)
      {
        this.isMultiFaceDivVisible = false;
        this.showDetails = false;
        if(decType == EDecisionType.HRRejected)
          {
            this.applicantDetailBehaviorCommunicationService.requestTabUpdate();
            this.answer.isMultiFaceDetected = false;
            this.answer.isAllowedMultipleFaceAnalysis = false;
            this.updateSuspicionOfCheating.emit(LogItem)
          }
      }
    if (detType == EDetectionType.UnverifiedNonFace || detType == EDetectionType.VerifiedNonFace)
      {
        this.isNonFaceDivVisible = false;
        this.showDetails = false;
        if(decType == EDecisionType.HRRejected)
          {
            this.applicantDetailBehaviorCommunicationService.requestTabUpdate();
            this.answer.faceDetectionStatus = EFaceDetectionStatus.VerifiedAndHasFace;
            this.answer.faceDetectionStatus = EFaceDetectionStatus.VerifiedAndHasFace;
            this.updateSuspicionOfCheating.emit(LogItem)
          }
      }
}
}
